module.exports = __webpack_public_path__ + "img/04.ed8bb97b.png";